module.exports = __webpack_public_path__ + "tables/media/Vector-1.588c0a39.svg";